module.exports = __webpack_public_path__ + "media/images/plans/dinner/main-19dd8d5e7cffe48f68147fd849c19893.jpg";